import React from 'react';
import { Message } from '../types';
import { UserIcon } from './utils/Icons';

const UserMessage: React.FC<{ message: Message; formatTime: (date: Date) => string; showHeader?: boolean; isConsecutiveMessage?: boolean }> = ({ message, formatTime, showHeader = true, isConsecutiveMessage = false }) => (
  <div className="message user" style={{ 
    marginTop: isConsecutiveMessage ? '0px' : '1px',
    marginBottom: isConsecutiveMessage ? '0px' : '1px',
    paddingTop: isConsecutiveMessage ? '0px' : undefined,
    paddingBottom: isConsecutiveMessage ? '0px' : undefined
  }}>
    <div className="message-content">
      {showHeader && (
        <div className="message-header">
          <span className="message-sender">
            <UserIcon />
            <span className="sender-name">{message.sender || 'User'}</span>
          </span>
          <span className="message-time">
            {message.timestamp instanceof Date && !isNaN(message.timestamp.getTime()) ? formatTime(message.timestamp) : ''}
          </span>
        </div>
      )}
      <div className="message-text">
        {message.text}
      </div>
    </div>
  </div>
);

export default UserMessage; 